import React, { useEffect, useState } from 'react';
// Constants
import { CompanyName, KeywordsPages, LocationCountry } from '../../utils/Constants';
// Data
import {
  aboutPageAdditionalMeta,
  aboutPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import AboutPageMainContainer from '../../components/about/AboutPageMainContainer';
import GeneralHeader from '../../components/header/GeneralHeader';
import PageDivider from '../../components/gallery/PageDivider';

function AboutPage() {
  const [hideNavbar, setHideNavbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById('scroll-section-about');
      if (!section) return;

      const sectionBottom = section.getBoundingClientRect().bottom;
      setHideNavbar(sectionBottom <= 130); // Hide navbar 50px before section disappears
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='About Me'
        desc={`Step into the world of ${CompanyName} in ${LocationCountry}, where indulgence, power, and submission collide. Explore My expertise, desires, and the experiences that await you.`}
        keywords={KeywordsPages}
        additionalMeta={aboutPageAdditionalMeta}
        structuredData={aboutPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen font-main bg-colour1 dark:bg-colour1 text-colour2 dark:text-colour2 overflow-hidden'>
        {/* Nav + header section */}
        <div
          id='scroll-section-about'
          className='grid bg-colour4 dark:bg-colour4 full_shadow_black_invert min-h-[45vh] max-h-[45vh]'
        >
          {/* Navigation */}
          <Navbar isHidden={hideNavbar} />

          {/* Divider */}
          <PageDivider />

          {/* Header */}
          <GeneralHeader
            page={`About Me`}
            title={`Learn About Miss Dominatrixa!`}
          />
        </div>

        {/* Main page content */}
        <AboutPageMainContainer />
      </div>
    </>
  );
}

export default AboutPage;
